var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPercent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22,
    r: 21,
    fill: "#0C1525",
    stroke: "url(#paint0_linear_9501_68763)",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9501_68763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5001 22C32.5001 20.645 31.9051 19.3667 30.8959 18.5633C31.0126 17.2117 30.5292 15.8875 29.5709 14.9283C28.6126 13.9708 27.2917 13.4858 26.0067 13.6325C24.3284 11.5025 20.7026 11.4625 19.0634 13.6033C16.3692 13.2833 13.7784 15.82 14.1334 18.4933C12.0034 20.1717 11.9626 23.7975 14.1042 25.4375C13.9876 26.7892 14.4709 28.1133 15.4292 29.0725C16.3876 30.03 17.7101 30.515 18.9934 30.3683C20.6717 32.4983 24.2976 32.5383 25.9367 30.3975C27.2867 30.5133 28.6117 30.0317 29.5709 29.0725C30.5284 28.1142 31.0117 26.7892 30.8667 25.5083C31.9051 24.635 32.5001 23.3567 32.5001 22.0017V22ZM19.1667 19.5C19.1717 18.41 20.8284 18.41 20.8334 19.5C20.8284 20.59 19.1717 20.59 19.1667 19.5ZM21.5267 24.9625C21.2701 25.3483 20.7492 25.4467 20.3709 25.1933C19.9876 24.9383 19.8842 24.4208 20.1401 24.0375L23.4734 19.0375C23.7284 18.655 24.2451 18.55 24.6292 18.8067C25.0126 19.0617 25.1159 19.5792 24.8601 19.9625L21.5267 24.9625ZM25.0001 25.3333C23.9101 25.3283 23.9101 23.6717 25.0001 23.6667C26.0901 23.6717 26.0901 25.3283 25.0001 25.3333Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9501_68763",
    x1: 2.5,
    y1: 64.5926,
    x2: 50.4216,
    y2: 59.8518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.150307,
    stopColor: "#FF0E46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336372,
    stopColor: "#E30036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548934,
    stopColor: "#FD264E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74141,
    stopColor: "#FF345D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.928887,
    stopColor: "#FD0A46"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9501_68763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(12.5 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercent);
export default __webpack_public_path__ + "static/media/percent.248b69f43429ee943c3d85966d3cee16.svg";
export { ForwardRef as ReactComponent };